export default {
  methods: {
    addPhonePadding(user) {
      if (!user.includes("@")) {
        let tel = user.replace(/ /g, "");
        tel = tel.replace("+", "");
        if (tel.length === 9) {
          // se 06, se 36
          tel = "36" + tel;
        }
        if (tel.startsWith("06")) {
          // 06 -> 36
          tel = "36" + tel.substring(2);
        }
        user = tel;
      }
      return user;
    },
  },
};
